/**
 * Defines reducers related to Primary Navigation bar feature.
 * this reducer will be combined in the store/RootReducer.js
 */

import { setUserDetails } from 'utils/app.utils';
import * as types from '../../constants/ActionTypes';

const initstate = {
  featureFlagsLoaded: false,
  showNewUI: false,
  mfaConfig: [],
  navigateTo: '',
  mfaResponseReceived: false,
  shouldSidebarRender: true,
  shouldHeaderRender: true,
  userDetails: {
    firstName: '',
    lastName: '',
    title: '',
  },
  msgsCount: 0,
  navigationBlockerFlag: false,
  navigationUnblockerFlag: false,
  previousPath: '',
  userDetailsFetched: false,
  userProfileError: false,
  initiatorDetails: {
    initiatorUserId: '',
    initiatorUserName: '',
    initiatorOrgId: '',
    initiatorFirstName: '',
    initiatorLastName: '',
  },
  isImpersonated: false,
  /** #genai Set by syncEvoneBannerVisibilitySaga (LD + third-party entitled-apps) */
  evoneBannerVisible: false,
  /** #genai LaunchDarkly showHorizonBanner (App syncs when flags load; used with third-party fetch) */
  ldShowEvoneBanner: true,
};

export default function (state = initstate, action) {
  const { type } = action;
  switch (type) {
    case types.MFA_CONFIG_RESPONDED: {
      const {
        mfaConfig, defaultApp, mfaResponseReceived,
      } = action;
      return {
        ...state,
        mfaConfig,
        defaultApp,
        mfaResponseReceived,
      };
    }

    case types.MFA_CONFIG_ERROR: {
      return {
        ...state,
        mfaConfig: [],
        defaultApp: {},
        mfaResponseReceived: true,
      };
    }

    case types.SET_EVONE_LD_SHOW_BANNER: {
      return {
        ...state,
        ldShowEvoneBanner: action.payload,
      };
    }

    case types.SET_EVONE_BANNER_VISIBILITY: {
      return {
        ...state,
        evoneBannerVisible: action.payload,
      };
    }

    case types.LOADERS_RESPONDED: {
      const {
        loaders,
      } = action;
      return {
        ...state,
        loaders,
      };
    }

    case types.USER_DETAILS_RESPONDED: {
      const { userDetails, initiatorDetails, isImpersonated } = action;
      return {
        ...state, userDetails, userDetailsFetched: true, initiatorDetails, isImpersonated, userProfileError: false,
      };
    }

    case types.USER_DETAILS_AFTER_UPDATE: {
      const { updatedDetails } = action;
      const userDetails = Object.assign(state.userDetails, updatedDetails);
      setUserDetails(userDetails);
      return { ...state, userDetails, userDetailsFetched: true };
    }

    case types.USER_DETAILS_ERROR: {
      const userDetails = {
        firstName: '',
        lastName: '',
        title: '',
      };
      return { ...state, userDetails, userProfileError: true };
    }

    case types.TOGGLE_SIDEBAR_SHOW: {
      return {
        ...state,
        shouldSidebarRender: true,
      };
    }

    case types.SET_FULL_SCREEN: {
      const { hideSidebar = false, hideHeader = false } = action.payload;
      return {
        ...state,
        shouldSidebarRender: (!hideSidebar),
        shouldHeaderRender: (!hideHeader),
      };
    }

    case types.TOGGLE_SIDEBAR_HIDE: {
      return {
        ...state,
        shouldSidebarRender: false,
      };
    }

    case types.NOTIFICATIONS_POLL_RESPONDED: {
      const { msgsCount } = action.payload;
      return {
        ...state,
        msgsCount,
      };
    }

    case types.NAVIGATE: {
      const { navigateTo } = action.payload;
      return {
        ...state,
        navigateTo,
      };
    }
    case types.NAVIGATION_BLOCKER: {
      return {
        ...state,
        navigationBlockerFlag: !state.navigationBlockerFlag,
      };
    }
    case types.NAVIGATION_UNBLOCKER: {
      return {
        ...state,
        navigationUnBlockerFlag: !state.navigationUnBlockerFlag,
      };
    }
    case types.SET_PREVIOUS_PATH: {
      const { prevPath } = action.payload;
      return {
        ...state,
        previousPath: prevPath,
      };
    }
    case types.SET_FEATURE_FLAGS_LOADED: {
      return {
        ...state,
        featureFlagsLoaded: action.payload,
      };
    }
    case types.SET_SHOW_NEW_UI: {
      return {
        ...state,
        showNewUI: action.payload,
      };
    }
    default:
      return state;
  }
}
